<template>
  <div class="detail">

    <!--    视频详情   -->
    <div v-if="data.contentTemplate == 3">
      <div>
        <video width="100%"
               autoplay="false"
               id="media"
               controls=""
               :src="data.recommendReason"></video>
      </div>
      <van-card>
        <!--    3    标签-->
        <template #title>
          <div class="card-title">{{ data.title }}</div>
        </template>
        <template #desc>
          <div class="card-introduce">{{ data.introduce }}</div>
        </template>
        <template #tags>
          <div class="card-time">
          <span v-if="data.createTime" style="float: left;">{{
              data.createTime
            }}
          </span>
            <div v-if="data.readNum" style="float: right;" class="">播放：{{ data.readNum }}</div>
          </div>
        </template>
        <template #price>
          <van-tag v-if="data.tag" style="float: left" class="card-tag" round type="primary">{{
              data.tag
            }}
          </van-tag>
          <!--          <div style="float: right" class="card-price">{{ data.price }}</div>-->
        </template>
      </van-card>

      <div class="ql-editor">
        <div>{{ data.content }}</div>
      </div>
    </div>

    <!--    内容详情-->
    <div v-else>
      <van-card>
        <!--    3    标签-->
        <template #title>
          <div class="card-title">{{ data.title }}</div>
        </template>
        <template #desc>
          <div class="card-introduce">{{ data.introduce }}</div>
        </template>
        <template #tags>
          <div class="card-time">
          <span v-if="data.createTime" style="float: left;">{{
              data.createTime
            }}
          </span>
            <div v-if="data.readNum" style="float: right;" class="">阅读：{{ data.readNum }}</div>
          </div>
        </template>
        <template #price>
          <van-tag v-if="data.tag" style="float: left" class="card-tag" round type="primary">{{
              data.tag
            }}
          </van-tag>
          <!--          <div style="float: right" class="card-price">{{ data.price }}</div>-->
        </template>
      </van-card>

      <div class="ql-editor">
        <div class="text" v-html="data.content"></div>
      </div>

      <div class="detail-ft" v-if="data.price || data.lat || data.phone">
        <van-row type="flex" justify="space-around">
          <van-col span="8">
            <div v-if="data.price" class="ft-price">{{ data.price }}</div>
          </van-col>
          <van-col span="7">
            <van-button v-if="data.lat && data.lng" round color="#37A1FFFF" @click="navigation">一键导航</van-button>
          </van-col>
          <van-col span="7">
            <van-button v-if="data.phone" round color="#096cef" @click="callPhone(data.phone)">拨打电话</van-button>
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="mapbox" v-show="false">
      <div class="map" id="container"></div>
    </div>
  </div>
</template>

<script>
import {infoDetail} from '@api/service'
import {callByCoin} from '@api/integralMall'

export default {
  name: 'info',
  data() {
    return {
      id: '', // id
      data: {}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getInfo()
  },
  methods: {

    // 调用导航
    navigation() {
      // 获取初始中心点并赋值
      var marker = new AMap.Marker({
        position: this.center
      })
      marker.markOnAMAP({
        position: marker.getPosition()
      })
    },

    // 调用拨号功能
    callPhone(phoneNumber) {
      const data = {phone: phoneNumber}
      this.$bridge.callHandler('callPhone', data, response => {
        console.log('response:', response)
      })
    },
    // 获取内容详情
    getInfo() {
      infoDetail(this.id).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.center = [this.data.lng, this.data.lat]
          this.data.content = this.data.content.replace("<iframe", `<video style="width:100%;outline:none;" controls="" autoplay=""`).replace("</iframe>", '</video>');
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.detail {
  background-color: white;
  height: 100%;

  .ql-editor {
    @include add_size($font_size_16);
  }

  video {
    height: 300px;
  }

  #media {
    height: 200px;
    background-color: black;
  }

  .ql-editor {
    padding-bottom: 80px;
    background-color: white;
    padding-top: 0;
  }

  .basic {
    border-radius: 0;
  }

  .function-div {
    padding-top: 15px;

    .function-img {
      width: 40px;
      height: 40px;
    }

    .img-default {
      text-align: center;
      @include add_size($font_size_16);
      padding-bottom: 15px;
    }

  }

  .van-card {
    background-color: white;
    border-top: 0.5px solid #EEEEEE;
  }

  .template-title {
    padding-left: 15px;
    line-height: 40px;
    @include add_size($font_size_18);
    //font-weight: bold;
  }

  .card-title {
    font-weight: bold;
    @include add_size($font_size_20);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .card-time {
    @include add_size($font_size_14);
    color: #999999FF
  }

  .card-introduce {
    padding-bottom: 10px;
    @include add_size($font_size_16);
    padding-top: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .card-tag {
    background-color: #e6e5e5;
    color: black;
    @include add_size($font_size_14);
    padding: 5px 8px;
  }

  .card-price {
    @include add_size($font_size_18);
    color: red;
  }

  .van-card__price {
    width: 100%;
    padding-top: 8px;

    .card-tag {
      padding: 3px 15px;
    }
  }

  .detail-ft {
    border-top: 0.5px solid #EEEEEE;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    background-color: white;
    padding: 0 5px;

    .van-col {
      margin: auto;
      line-height: 12px;
    }

    .ft-price {
      @include add_size($font_size_18);
      color: red;
      line-height: 50px;
    }

    .van-button {
      padding: 10px 20px;
      height: 35px;
      font-size: 15px;
    }
  }

}


</style>
